/*
 * Delete-product.ts
 * Description: Includes the declaration
 * of the function for validating a product
 */

// Importing variables
import {
    MissingFirstName, TooLongFirstName, MissingTags,
    InvalidCookTime, MissingVariations, InvalidCode,
} from '@/ts/variables';

export interface Product {
    name: string;
    cook_time: number;
    description: string;
    code: number;
    tags: string[];
    variations: {
        created: any;
        old: any;
    };
    image: string;
}

/**
 * Validating a product
 *
 * @param {String[]} errors - a list of errors
 * @param {Product} data - data to be validated
 */
export function validateProduct(errors: string[], data: Product) {
    // Validating name
    if (data.name.length === 0) { errors.push(MissingFirstName); }
    if (data.name.length > 255) { errors.push(TooLongFirstName); }

    // Validating tags
    if (data.tags.length === 0) { errors.push(MissingTags); }

    // Validating variations
    if (data.variations.created.length === 0 && data.variations.old.length === 0) { errors.push(MissingVariations); }

    // Validating code
    if (data.code === 0) { errors.push(InvalidCode); }

    // Validating cooking time
    if (data.cook_time < 1) { errors.push(InvalidCookTime); }
}
